import React from 'react';
import './AffiliateBanners.css';

const AffiliateBanners = ({ type = 'horizontal' }) => {
  const banners = {
    // Large horizontal banner (980x120) - Real affiliate banner
    hero: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031440&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031440&as=1971524470&t=1&tk=1&i=1" 
          width="980" 
          height="120" 
          border="0" 
          alt="Leksaksbilar.se - Bästa leksaksbilarna"
          style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}}
        />
      </a>
    ),
    
    // Medium horizontal banner (728x90) - Real affiliate banner
    medium: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031399&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031399&as=1971524470&t=1&tk=1&i=1" 
          width="728" 
          height="90" 
          border="0" 
          alt="Leksaksbilar.se - Modellbilar och leksaksbilar"
          style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}}
        />
      </a>
    ),
    
    // Small horizontal banner (468x60) - Real affiliate banner
    small: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031431&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031431&as=1971524470&t=1&tk=1&i=1" 
          width="468" 
          height="60" 
          border="0" 
          alt="Leksaksbilar.se - Leksaksbilar online"
          style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}}
        />
      </a>
    ),
    
    // Square banner (250x250)
    square: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031414&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031414&as=1971524470&t=1&tk=1&i=1" 
          width="250" 
          height="250" 
          border="0" 
          alt="Leksaksbilar.se - Hot Wheels och LEGO"
        />
      </a>
    ),
    
    // Vertical banner (160x600) - Real affiliate banner
    vertical: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031412&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031412&as=1971524470&t=1&tk=1&i=1" 
          width="160" 
          height="600" 
          border="0" 
          alt="Leksaksbilar.se - RC-bilar och modellbilar"
          style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}}
        />
      </a>
    ),
    
    // Wide banner (300x250)
    wide: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031416&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031416&as=1971524470&t=1&tk=1&i=1" 
          width="300" 
          height="250" 
          border="0" 
          alt="Leksaksbilar.se - Siku och Majorette"
        />
      </a>
    ),
    
    // Tall vertical banner (300x600)
    tall: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031418&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031418&as=1971524470&t=1&tk=1&i=1" 
          width="300" 
          height="600" 
          border="0" 
          alt="Leksaksbilar.se - Premium leksaksbilar"
        />
      </a>
    ),
    
    // Medium vertical banner (250x360)
    mediumVertical: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031406&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031406&as=1971524470&t=1&tk=1&i=1" 
          width="250" 
          height="360" 
          border="0" 
          alt="Leksaksbilar.se - Modellbilar samlare"
        />
      </a>
    ),
    
    // Thin vertical banner (140x350)
    thinVertical: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031410&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031410&as=1971524470&t=1&tk=1&i=1" 
          width="140" 
          height="350" 
          border="0" 
          alt="Leksaksbilar.se - Hot Wheels samlare"
        />
      </a>
    ),
    
    // Alternative hero banner (980x120)
    heroAlt: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031401&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031401&as=1971524470&t=1&tk=1&i=1" 
          width="980" 
          height="120" 
          border="0" 
          alt="Leksaksbilar.se - Bästa leksaksbilarna online"
        />
      </a>
    ),
    
    // Alternative vertical banner (160x600) - Real affiliate banner
    verticalAlt: (
      <a href="https://on.leksaksbilar.se/t/t?a=1954031383&as=1971524470&t=2&tk=1" target="_blank" rel="noopener noreferrer">
        <img 
          src="https://track.adtraction.com/t/t?a=1954031383&as=1971524470&t=1&tk=1&i=1" 
          width="160" 
          height="600" 
          border="0" 
          alt="Leksaksbilar.se - RC-bilar och modellbilar"
          style={{maxWidth: '100%', height: 'auto', borderRadius: '8px'}}
        />
      </a>
    )
  };

  return (
    <div className={`affiliate-banner affiliate-banner--${type}`}>
      {banners[type] || banners.medium}
    </div>
  );
};

export default AffiliateBanners;
